import React from "react";
import { useTheme } from "../../../context/ThemeContext";
import "./Theme.scss";

const Theme = () => {
  const { theme } = useTheme();

  // Apply theme styles to document body to affect all components
  React.useEffect(() => {
    document.body.style.backgroundColor = theme.backgroundColor;
    document.body.style.color = theme.textColor;
    document.body.className = `theme-${theme.name}`;

    return () => {
      document.body.style.backgroundColor = "";
      document.body.style.color = "";
      document.body.className = "";
    };
  }, [theme]);

  return (
    <div
      className={`theme theme--${theme.name}`}
      style={{
        backgroundColor: theme.backgroundColor,
        color: theme.textColor,
      }}
    />
  );
};

export default Theme;
